module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am417-527f5c95e5f3e71cf2066bf2c115be0c.jpg";